// Copyright (c) 2017 Deere & Company

import actions from '../actions-list';
import {sortCollection} from '../../../shared/services/collections';

export const initializeList = (dealers, searchFilters) => ({
    data: sortCollection(searchFilters.sortBy, searchFilters.sortDirection, dealers),
    type: actions.UPDATE_LABOR_RATE_DEALERS_FILTERED
});



// WEBPACK FOOTER //
// ./src/claim/labor-rate-dealers/action-creators/dealers-filtered.js